import * as React from 'react';
import { Button } from '@mui/material';

import { Customer } from 'types/Customer';

interface Props {
  customer: Customer;
  onCancel: () => void;
  onDelete: () => void;
}

export const DeletePrompt: React.FC<Props> = (props) => {
  const { customer, onCancel, onDelete } = props;

  return (
    <div className="space-y-4">
      <h6>
        Deleting this Customer ID will remove it from {customer.count} containers. Are you sure?
      </h6>
      <div className="space-x-2 flex children:flex-grow">
        {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        <Button onClick={onCancel} variant="outlined" className="flex-grow" color="gray">
          Cancel
        </Button>
        <Button onClick={onDelete} variant="outlined" className="flex-grow" color="error">
          Delete
        </Button>
      </div>
    </div>
  );
};
DeletePrompt.displayName = 'CustomerTag.Edit.DeletePrompt';
